import StatusBadgeComponent from './status-badge.component'

const StatusBadgeModule = angular.module('cdbl.status-badge', [

])
  .component('cdblStatusBadge', StatusBadgeComponent)
  .name

export default StatusBadgeModule
